$(document).ready(function(){

	// Prevent multiple form submissions
	var submitBtn = '.go-checkout';

	if(!$(submitBtn).hasClass('stay-disabled')){
		$(submitBtn).removeAttr('disabled');
	}

	$(submitBtn).on('click',function(){
	    $.each($(submitBtn), function(){
	    	var buttonDisabled = true;
            if ($(this).data('form-container')
				&& $($(this).data('form-container')).closest('form').length
				&& !$($(this).data('form-container')).closest('form').parsley().validate()
			) {
                buttonDisabled = false;
			}
			$(this).attr('disabled', buttonDisabled);
	    });
	});

	$('button[type=reset]').on('click', function(){
		var $form = $(this).closest('form');
		$form.find("[data-validate-maxlength]").each(function(){
			var maxLen = $(this).data('validate-maxlength');
			if ($(this).data('bq.charLimit') !== undefined) {
                $(this).data('bq.charLimit').updateRemaining(maxLen);
			}
		});
	});

  var webformSelector = 'form.bq-form';
  $(webformSelector).on('submit', function(){
    if ($(this).parsley().validate()) {
        $('button:submit', this).prop('disabled', true);
    }
  });
});
